export const PAYMENT_PRODUCT_TYPE = {
  MODEL_SUPPORT: 'MODEL_SUPPORT',
  SEEDING_PASS: 'SEEDING_PASS',
  SEEDING_PASS_RECOVER: 'SEEDING_PASS_RECOVER',
  SEEDING_PASS_HISTORY: 'SEEDING_PASS_HISTORY',
  SEEDING_PASS_BEAUTY_SINGLE: 'SEEDING_PASS_BEAUTY_SINGLE',
  SEEDING_PASS_BEAUTY_COMMISSION_ONLY: 'SEEDING_PASS_BEAUTY_COMMISSION_ONLY',
  SEEDING_PASS_BEAUTY_YEARLY: 'SEEDING_PASS_BEAUTY_YEARLY',
  SEEDING: 'SEEDING',
  SEEDING_FIRST: 'SEEDING_FIRST',
  SEEDING_COMMISSION: 'SEEDING_COMMISSION',
  SEEDING_INSPECTION_FEE: 'SEEDING_INSPECTION_FEE',
  SEEDING_VIDEO_CLEAN: 'SEEDING_VIDEO_CLEAN',
  SNS_PASS: 'SNS_PASS',
  SNS_PASS_CANCEL: 'SNS_PASS_CANCEL',
  SNS_PASS_RECOVER: 'SNS_PASS_RECOVER',
  SNS_INSTALL: 'SNS_INSTALL',
};
